module.exports = __webpack_public_path__ + "static/media/logo.3bd025fe.png";